import { ElLoading } from 'element-plus'
import { ElMessage } from 'element-plus'
import { ElMessageBox } from 'element-plus'
import { ElNotification } from 'element-plus'
import { JSEncrypt } from "jsencrypt";
import axios from 'axios'
import router from './router'
import store from '@/store/index'
import { tc } from '@/languages'
import html2canvas from 'html2canvas'
import { jsPDF } from "jspdf";

let loading = undefined;

const showLoading = () => {
    loading = ElLoading.service({
        lock: true,
        text: tc('global.Loading'),
        background: 'rgba(0, 0, 0, 0.7)',
    });
};

const closeLoading = () => {
    if (loading != undefined) {
        loading.close();
        loading = undefined;
    }
};

const showConfirm = (title, text, option) => {
    option = {
        ...{
            confirmButtonText: tc('global.Confirm'),
            cancelButtonText: tc('global.Cancel'),
        }, ...option
    };
    return ElMessageBox.confirm(text, title, option);
};

const showAlert = (title, text, option) => {
    return ElMessageBox.alert(text, title, option);
};

const showMessage = (type, msg) => {
    ElMessage({ message: msg, type: type, });
};

const showNotification = (type, title, msg) => {
    ElNotification({ title: title, message: msg, type: type, });
};

const refreshPublicKey = () => {
    let json = localStorage.getItem('PublicKey');
    let obj = JSON.parse(json);

    if (obj === null || obj.validityTime === null || new Date() > obj.validityTime) {
        showLoading();
        getNewKey();
    } else {
        showLoading();
        axios.get('/MainSite/Valid', { params: { context: rsaEncrypt("Hello") } })
            .then(response => {
                if (!response.success) {
                    getNewKey();
                }
            }).catch(() => {
                getNewKey();
            }).then(() => {
                closeLoading();
            });
    }
};

const getNewKey = () => {
    axios.get('/MainSite/RSAKey/Key').then(response => {
        let obj = {};
        obj.key = response.content;
        obj.validityTime = new Date().setMinutes(new Date().getMinutes() + 10);
        localStorage.setItem('PublicKey', JSON.stringify(obj));
    }).then(() => {
        closeLoading();
    });
};

const rsaEncrypt = (text) => {
    let key = JSON.parse(localStorage.getItem('PublicKey')).key
    let jsEncrypt = new JSEncrypt({ default_key_size: 2048 });
    jsEncrypt.setPublicKey(key);
    return jsEncrypt.encrypt(text);
};

const isEmpty = (str) => {
    return str == undefined || str == null || str === '';
};

const filterRouter = () => {
    //let userRole = store.state.userMenu.roles;
    let [...menus] = router.getRoutes();
    return menus.filter(p => {
        // if (p.name && p.meta.root) {
        //     if (p.children.length > 0) {
        //         p.children = p.children.filter(c => c.meta.role == undefined || (c.meta.role & userRole.value) != 0);
        //         return p.children.length > 0;                
        //     }
        //     return p.meta.role == undefined || (p.meta.role & userRole.value) != 0;
        // }
        // return false;
        return p.name && p.meta.root;
    });
};

const getDefaultPermission = () => {
    let permission = [];
    let allmenu = filterRouter();

    allmenu.forEach((val) => {
        let item = {
            name: val.name,
            showSubItem: val.meta.showSubItem,
            enable: val.meta.enable,
            icon: val.meta.icon,
            omPermission:val.meta.omPermission
        };

        if (val.children.length > 0) {
            item.children = [];
            val.children.forEach((child) => {
                item.children.push({
                    name: child.name,
                    permission: JSON.parse(JSON.stringify(child.meta.permission ?? [])),
                    enable: child.meta.enable,
                    hidden: child.meta.hidden,
                    omPermission:child.meta.omPermission,
                    bind:child.meta.bind,
                });
            });
        }
        permission.push(item);
    });

    return permission;
};

const getAllPermission = () => {
    let permission = [];
    let allmenu = filterRouter();

    allmenu.forEach((val) => {
        let item = {
            name: val.name,
            showSubItem: val.meta.showSubItem,
            enable:true,
            icon:val.meta.icon,
            omPermission:val.meta.omPermission
        };

        if (val.children.length > 0) {
            item.children = [];
            val.children.forEach((child) => {
                let [...tempPermission] = JSON.parse(JSON.stringify(child.meta.permission ?? []));
                tempPermission.forEach(p => p.value = true);
                item.children.push({
                    name: child.name,
                    permission: JSON.parse(JSON.stringify(tempPermission)),//.forEach( p => p.value = true),
                    enable: child.meta.enable === undefined ? undefined : true,
                    hidden: child.meta.hidden,
                    omPermission:child.meta.omPermission,
                    bind: child.meta.bind,
                });
            });
        }

        permission.push(item);
    });

    return permission;
};

const getUserAdminPermission = () =>{
    let permission = [];
    let allmenu = filterRouter();

    allmenu.forEach((val) => {       
        if(val.meta.omPermission)
            return;
        let item = {
            name: val.name,
            showSubItem: val.meta.showSubItem,
            enable:true,
            icon:val.meta.icon,
            omPermission:val.meta.omPermission
        };

        if (val.children.length > 0) {
            item.children = [];
            val.children.forEach((child) => {
                let [...tempPermission] = JSON.parse(JSON.stringify(child.meta.permission ?? []));
                tempPermission.forEach(p => p.value = true);
                if(!child.meta.omPermission){
                    item.children.push({
                        name: child.name,
                        permission: JSON.parse(JSON.stringify(tempPermission)),//.forEach( p => p.value = true),
                        enable: child.meta.enable === undefined ? undefined : true,
                        hidden: child.meta.hidden,
                        omPermission:child.meta.omPermission,
                        bind: child.meta.bind,
                    });
                }
            });
        }

        permission.push(item);
    });

    return permission;
};

const mergePermission = (permission) => {
    let defaut = JSON.parse(JSON.stringify(getDefaultPermission()));
    defaut.forEach((defaultItem) => {
        let permissionItem = permission.find(p => p.name === defaultItem.name);
        if (permissionItem) {
            if (defaultItem.enable !== undefined) {
                defaultItem.enable = permissionItem.enable;
            }
            defaultItem.children.forEach(defaultChild => {
                let permissionChild = permissionItem.children.find(c => c.name == defaultChild.name);
                if (permissionChild) {
                    if (!defaultItem.showSubItem) {
                        defaultChild.enable = defaultItem.enable;
                    }
                    else if (defaultChild.enable !== undefined) {
                        defaultChild.enable = permissionChild.enable;
                    }

                    defaultChild.permission.forEach(defaultPermission => {
                        let tempPermission = permissionChild.permission.find(p => p.key == defaultPermission.key);
                        if (tempPermission) {
                            defaultPermission.value = tempPermission.value;
                        }
                    });
                }
            });
        }
    });
    return defaut;
};

const refreshPermission = (userInfo) => new Promise((resolve) => {
    axios.get('/DBHub/UserInfo')
        .then(response => {
            if (response.success) {
                response.content.expiration = new Date().getTime() + (30 * 60 * 1000);
                localStorage.setItem('User', JSON.stringify(response.content));
                store.dispatch('setUser', response.content);
            }
            axios.get('/DBHub/Permission/Detail', { params: { role: userInfo.role, groupId: userInfo.dBHubPermission } })
                .then(response => {
                    if (response.success) {
                        store.dispatch('setPermission', mergePermission(response.content.permission));
                    }
                    else {
                        if (userInfo.role == 63)
                            store.dispatch('setPermission', getUserAdminPermission());
                        else if (userInfo.role >= 127)
                            store.dispatch('setPermission', getAllPermission());
                        else
                            store.dispatch('setPermission', getDefaultPermission());
                    }
                    resolve();
                });
        });
});

const initPermission = (refresh) => new Promise((resolve) => {
    let userMenu = store.state.userMenu;

    if(refresh){
        refreshJWT();
    }

    if (refresh || !store.state.userMenu.permission) {
        if (store.state.userMenu.role >= 127) {
            store.dispatch('setPermission', getAllPermission());
            resolve();
        }
        else if (store.state.userMenu.role == 63) {
            store.dispatch('setPermission', getUserAdminPermission());
            resolve();
        }
        else {
            refreshPermission(userMenu).then(() => {
                resolve();
            });
        }
    }
    else {
        resolve();
    }
});

const refreshJWT = () => {
    axios.get('/MainSite/Login/JWT')
        .then(response => {
            if (response.success) {
                localStorage.setItem("JWT", response.content);
            }
        });
};

const checkMenu = (menu) => {
    if (store.state.userMenu.permission) {
        let [...content] = store.state.userMenu.permission;
        for (let i = 0; i < menu.length; i++) {
            if (i === 0) {
                content = content.find(p => p.name === menu[i].name);
                if (!content) return false;
                if (!content.showSubItem)
                    break;
                else if (content.children.filter(c => !c.hidden && c.enable).length == 0)
                    return false;
            }
            else {
                content = content.children.find(p => p.name === menu[i].name && !p.hidden);
            }

            if (!content)
                return false;
        }
        return content.enable;
    }

    return false;
};

//校验路由权限
const checkRoutePermission = (route) => {
    let [...content] = store.state.userMenu.permission;
    for (let i = 0; i < route.length; i++) {
        if (i === 0) {
            content = content.find(p => p.name === route[i].name);
            if (!content.showSubItem)
                break;
        }
        else {
            content = content.children.find(p => p.name === route[i].name);            
        }

        if (!content)
            return false;
    }

    if (content.enable === undefined && content.bind && content.bind.length > 0) {
        for (let i = 0; i < content.bind.length; i++) {
            return checkPagePermission(content.bind[i]);
        }
    }
    return content.enable;
};

const checkPagePermission = (point) => {
    let path = point.split('.');
    let [...menuPath] = router.currentRoute.value.matched;
    let [...permission] = store.state.userMenu.permission;
    let content = {};

    if (path.length == 1) {
        for (let i = 0; i < menuPath.length; i++) {
            if (i === 0) {
                content = permission.find(p => p.name == menuPath[i].name);
            } else {
                content = content.children.find(p => p.name == menuPath[i].name);
            }

            if (!content || !content.enable) {
                return false;
            }
        }

        if (content.permission && content.permission.length > 0) {
            content = content.permission.find(p => p.key === point);
            if (content) {
                return content.value;
            }
        }
    }
    else if (path.length > 1) {
        for (let i = 0; i < path.length - 1; i++) {
            if (i === 0) {
                content = permission.find(p => p.name == path[i]);
            }
            else {
                content = content.children.find(p => p.name == path[i]);
            }

            if (!content || !content.enable) {
                return false;
            }
        }

        if (content.permission && content.permission.length > 0) {
            content = content.permission.find(p => p.key === path[path.length - 1]);
            if (content) {
                return content.value;
            }
        }
    }

    return false;
};

const defaultDateRange = () => {
    return [
        {
            text: tc("global.LastWeek"),
            value: () => {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                return [start, end]
            },
        },
        {
            text: tc("global.LastMonth"),
            value: () => {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                return [start, end]
            },
        },
        {
            text: tc("global.Last3Month"),
            value: () => {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                return [start, end]
            },
        },
    ];
};

const getPicture = (element, callback) => {
    html2canvas(element,{
        allowTaint:true,
        useCORS:true,
        width:element.scrollWeight,
        height:element.scrollHeight
    }).then((canvas) => {
        callback(canvas);
    });
};

// const savePDF = (title,canvas) =>{
//     let pageData = canvas.toDataURL('image/png',1);
//     const pdf = new jsPDF({
//         unit: "mm", // 单位，本示例为mm
//         format: "a4", // 页面大小
//         orientation: "portrait", // 页面方向，portrait: 纵向，landscape: 横向
//         putOnlyUsedFonts: true, // 只包含使用的字体
//         compress: true, // 压缩文档
//         precision: 16, // 浮点数的精度
//     });

//     // 定义页面边距
//     const PAGE_MARGIN = 10;
//     // 页面宽高
//     const width = pdf.internal.pageSize.getWidth();
//     const height = pdf.internal.pageSize.getHeight();
//     const pdfCentWidth = width - PAGE_MARGIN * 2;
//     const pdfCentHeight = height - PAGE_MARGIN * 2;
//     const widthRatio = pdfCentWidth / canvas.width;
//     const heightRatio = pdfCentHeight / canvas.height;
//     const ratio = Math.min(widthRatio, heightRatio);
//     // 得到图片宽高
//     const w = canvas.width * ratio;
//     const h = canvas.height * ratio;
//     pdf.addImage(pageData, 'JPEG', PAGE_MARGIN,PAGE_MARGIN ,w,h);
//     pdf.save(title + '.pdf');
// };

const savePDF = (title, canvas) => {
    const pdf = new jsPDF({
        unit: "mm",
        format: "a4",
        orientation: "portrait",
        compress: true,
    });

    const PAGE_MARGIN = 10;
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    
    const availablePdfWidth = pdfWidth - PAGE_MARGIN * 2;
    const availablePdfHeight = pdfHeight - PAGE_MARGIN * 2;

    const scale = availablePdfWidth / canvas.width;
    const imgWidthInPdf = canvas.width * scale;

    const tempCanvas = document.createElement('canvas');
    const ctx = tempCanvas.getContext('2d');
    tempCanvas.width = canvas.width;

    let currentY = 0;
    let isFirstPage = true;

    // 【配置项】
    const SEARCH_RANGE = 500;       // 扩大搜索范围，覆盖更多可能的卡片高度
    const GAP_THRESHOLD = 0.05;     // 稍微调低，要求更纯粹的空白
    const SCAN_STEP = 5;            
    const MIN_CONTENT_HEIGHT = 100; // 当前页最少要保留的内容高度，防止留白过多

    while (currentY < canvas.height) {
        if (!isFirstPage) {
            pdf.addPage();
        }
        isFirstPage = false;

        const maxSliceHeight = availablePdfHeight / scale;
        const remainingHeight = canvas.height - currentY;

        // 最后一页：直接全部放入
        if (remainingHeight <= maxSliceHeight + 10) {
            renderAndAdd(currentY, remainingHeight);
            break;
        }

        const targetCut = currentY + maxSliceHeight;
        
        // 确定扫描区域
        const scanStart = Math.max(currentY, targetCut - SEARCH_RANGE);
        const scanEnd = Math.min(canvas.height, targetCut + SEARCH_RANGE);
        const scanH = scanEnd - scanStart;

        if (scanH <= 10) {
            renderAndAdd(currentY, maxSliceHeight);
            currentY += maxSliceHeight;
            continue;
        }

        // 1. 扫描密度
        const scanW = Math.floor(canvas.width * 0.8);
        const scanX = Math.floor((canvas.width - scanW) / 2);
        
        const scanCanvas = document.createElement('canvas');
        scanCanvas.width = scanW;
        scanCanvas.height = scanH;
        const scanCtx = scanCanvas.getContext('2d');
        scanCtx.drawImage(canvas, scanX, scanStart, scanW, scanH, 0, 0, scanW, scanH);
        
        const imgData = scanCtx.getImageData(0, 0, scanW, scanH).data;
        const densities = [];
        
        let bestOffset = -1;      
        let minDensity = 1.0;     

        for (let y = 0; y < scanH; y += SCAN_STEP) {
            let darkCount = 0;
            const rowBase = y * scanW * 4;
            for (let x = 0; x < scanW; x++) {
                const idx = rowBase + x * 4;
                if ((imgData[idx] + imgData[idx+1] + imgData[idx+2]) / 3 < 220) {
                    darkCount++;
                }
            }
            const density = darkCount / scanW;
            densities.push(density);

            // 【关键】记录全局最低密度点及其位置
            if (density < minDensity) {
                minDensity = density;
                bestOffset = y;
            }
        }

        // 2. 决策逻辑
        let finalCutY = targetCut; 
        let foundGap = false;

        const centerOffset = targetCut - scanStart;
        const centerIndex = Math.floor(centerOffset / SCAN_STEP);

        // 策略 A: 寻找完美空白 (密度 < 阈值)
        for (let offset = 0; offset < densities.length; offset++) {
            let rIdx = centerIndex + offset;
            if (rIdx < densities.length && densities[rIdx] < GAP_THRESHOLD) {
                finalCutY = scanStart + rIdx * SCAN_STEP;
                foundGap = true;
                break;
            }
            let lIdx = centerIndex - offset;
            if (lIdx >= 0 && densities[lIdx] < GAP_THRESHOLD) {
                finalCutY = scanStart + lIdx * SCAN_STEP;
                foundGap = true;
                break;
            }
        }

        // 策略 B: 如果没有完美空白，使用 bestOffset (最稀疏点)
        if (!foundGap) {
            if (bestOffset !== -1) {
                const potentialCut = scanStart + bestOffset;
                
                // 检查这个“最稀疏点”是否合理：
                // 1. 不能太靠近当前页顶部（否则当前页全是白的）
                // 2. 不能太靠近搜索区底部（否则下一页开头就是白的）
                
                if (potentialCut > currentY + MIN_CONTENT_HEIGHT) {
                    finalCutY = potentialCut;
                    console.log(`未找到完美空白，采用最稀疏点 (密度:${minDensity.toFixed(3)}) 进行切割`);
                } else {
                    // 如果最稀疏点太靠上，说明整个搜索区都很密集，或者卡片非常大
                    // 此时启用保守策略：只保留当前页前 70%，剩下的推后
                    finalCutY = currentY + (maxSliceHeight * 0.7);
                    console.log(`最稀疏点太靠上，启用保守截断策略`);
                }
            } else {
                // 极端 fallback
                finalCutY = currentY + (maxSliceHeight * 0.7);
            }
        }

        // 3. 执行切割
        const sliceHeight = Math.max(finalCutY - currentY, 50); 
        const safeHeight = Math.min(sliceHeight, remainingHeight);

        renderAndAdd(currentY, safeHeight);
        currentY += safeHeight;
    }

    function renderAndAdd(y, h) {
        tempCanvas.height = Math.ceil(h);
        ctx.clearRect(0, 0, tempCanvas.width, tempCanvas.height);
        ctx.drawImage(canvas, 0, y, canvas.width, h, 0, 0, canvas.width, h);
        const data = tempCanvas.toDataURL('image/jpeg', 0.95);
        pdf.addImage(data, 'JPEG', PAGE_MARGIN, PAGE_MARGIN, imgWidthInPdf, h * scale);
    }

    pdf.save(title + '.pdf');
};

// const canvasToPDFBlob = (title, canvas) => {
//     return new Promise((resolve) => {
//         let pageData = canvas.toDataURL('image/png', 1);
//         const pdf = new jsPDF({
//             unit: "mm",
//             format: "a4",
//             orientation: "portrait",
//             putOnlyUsedFonts: true,
//             compress: true,
//             precision: 16,
//         });

//         const PAGE_MARGIN = 10;
//         const width = pdf.internal.pageSize.getWidth();
//         const height = pdf.internal.pageSize.getHeight();
//         const pdfCentWidth = width - PAGE_MARGIN * 2;
//         const pdfCentHeight = height - PAGE_MARGIN * 2;
//         const widthRatio = pdfCentWidth / canvas.width;
//         const heightRatio = pdfCentHeight / canvas.height;
//         const ratio = Math.min(widthRatio, heightRatio);
//         const w = canvas.width * ratio;
//         const h = canvas.height * ratio;
//         pdf.addImage(pageData, 'JPEG', PAGE_MARGIN, PAGE_MARGIN, w, h);
        
//         const blob = pdf.output('blob');
//         resolve(blob);
//     });
// };

const canvasToPDFBlob = (title, canvas) => {
    return new Promise((resolve) => {
        // 1. 获取 Canvas 数据
        // 建议用 image/jpeg 以获得更小体积，或者 image/png 保证清晰度
        //const pageData = canvas.toDataURL('image/jpeg', 0.95); 
        
        const pdf = new jsPDF({
            unit: "mm",
            format: "a4",
            orientation: "portrait",
            putOnlyUsedFonts: true,
            compress: true,
        });

        const PAGE_MARGIN = 10;
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        
        // 计算 PDF 单页可用的宽高
        const availablePdfWidth = pdfWidth - PAGE_MARGIN * 2;
        const availablePdfHeight = pdfHeight - PAGE_MARGIN * 2;

        // 2. 计算缩放比例：仅根据宽度缩放，高度保持比例（以便后续切割）
        // 这样能保证内容清晰，不会被强行压缩到一页
        const scale = availablePdfWidth / canvas.width;
        
        // 计算 Canvas 在 PDF 中的实际显示宽度
        const imgWidthInPdf = canvas.width * scale;
        // 计算 Canvas 在 PDF 中的实际显示总高度
        //const imgTotalHeightInPdf = canvas.height * scale;

        let position = 0; // 当前切割位置的偏移量 (在 PDF 坐标系中)
        let canvasOffsetY = 0; // 当前在 Canvas 源图中的 Y 轴偏移量 (像素)

        // 3. 循环处理每一页
        while (canvasOffsetY < canvas.height) {
            // 如果是第一页之后，先添加新页
            if (position > 0) {
                pdf.addPage();
            }

            // 计算当前页需要截取的 Canvas 高度 (像素)
            // 逻辑：PDF 一页能显示 availablePdfHeight，反推回 Canvas 是多少像素
            const canvasSliceHeight = availablePdfHeight / scale;
            
            // 创建一个临时的 Canvas 用于截取当前页的内容
            const tempCanvas = document.createElement('canvas');
            const ctx = tempCanvas.getContext('2d');
            
            // 设置临时 Canvas 尺寸 (宽度不变，高度为当前切片高度)
            // 注意：这里要处理最后一片可能不足一页的情况
            const currentSliceHeight = Math.min(canvasSliceHeight, canvas.height - canvasOffsetY);
            
            tempCanvas.width = canvas.width;
            tempCanvas.height = currentSliceHeight;

            // 绘制截取部分：drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight)
            ctx.drawImage(
                canvas, 
                0, canvasOffsetY, canvas.width, currentSliceHeight, // 源图截取区域
                0, 0, canvas.width, currentSliceHeight              // 目标绘制区域
            );

            const sliceData = tempCanvas.toDataURL('image/jpeg', 0.95);

            // 将截取的图片添加到 PDF
            // 高度使用 availablePdfHeight (满页)，但如果是最后一页且内容不足，可以动态计算
            const currentImgHeightInPdf = currentSliceHeight * scale;
            
            pdf.addImage(sliceData, 'JPEG', PAGE_MARGIN, PAGE_MARGIN, imgWidthInPdf, currentImgHeightInPdf);

            // 更新偏移量
            canvasOffsetY += currentSliceHeight;
            position += availablePdfHeight;
        }

        const blob = pdf.output('blob');
        resolve(blob);
    });
};

const debounce =(fn,time) =>{
    let timer;
    return (...args) => {            
        if(timer){
            clearTimeout(timer);
        }        
        timer = setTimeout(() => {
            fn.apply(this,args);
        }, time);
    }
}

export const arrayGroupBy = (array, callback) => {    
    return array.reduce((acc, item) => {
        let type = callback(item);
        let exists = acc.find( i => i.key === type);
        
        if (exists) {
            exists.items.push(item);
        } else {
            acc.push({
                key :type,
                items:[item]
            });
        }
        return acc;
    }, []);
}

export const saveBlob = (blob, fileName) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export const dataFormatTool = (date,expression = 'YY-MM-DD') => {
    let tempDate = new Date(date);
    let year = tempDate.getFullYear();
    let month = (tempDate.getMonth() + 1).toString().padStart(2,'0');
    let day = tempDate.getDate().toString().padStart(2,'0');
    let hours = tempDate.getHours().toString().padStart(2,'0');
    let minutes = tempDate.getMinutes().toString().padStart(2,'0');
    let seconds = tempDate.getSeconds().toString().padStart(2,'0');

    return expression.replace('YY',year).replace('MM',month).replace('DD',day).replace('hh',hours).replace('mm',minutes).replace('ss',seconds);
}

export {
    showLoading, closeLoading, showMessage, showConfirm, showAlert, showNotification,debounce,
    refreshPublicKey, rsaEncrypt,isEmpty,initPermission,filterRouter,
    checkMenu,
    checkRoutePermission,checkPagePermission,defaultDateRange,
    getPicture,savePDF,canvasToPDFBlob,getDefaultPermission, mergePermission   
}